var __slice = [].slice,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define([], function() {
  return {
    of: function() {
      var Mixed, base, method, mixin, mixins, name, _i, _ref;
      base = arguments[0], mixins = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      Mixed = (function(_super) {

        __extends(Mixed, _super);

        function Mixed() {
          Mixed.__super__.constructor.apply(this, arguments);
        }

        return Mixed;

      })(base);
      for (_i = mixins.length - 1; _i >= 0; _i += -1) {
        mixin = mixins[_i];
        _ref = mixin.prototype;
        for (name in _ref) {
          method = _ref[name];
          Mixed.prototype[name] = method;
        }
      }
      return Mixed;
    }
  };
});
